import { render, staticRenderFns } from "./ListItemRunnerSponsor.vue?vue&type=template&id=a4205308&scoped=true"
import script from "./ListItemRunnerSponsor.vue?vue&type=script&lang=js"
export * from "./ListItemRunnerSponsor.vue?vue&type=script&lang=js"
import style0 from "./ListItemRunnerSponsor.vue?vue&type=style&index=0&id=a4205308&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4205308",
  null
  
)

export default component.exports